import {DataFrame, DataFrameRow} from 'data-frames/DataFrameTypes';

/**
 * Return a data frame that only includes the rows that passes the predicate callback.
 */
export default function filterRows(
  dataFrame: DataFrame,
  predicate: (dataRow: DataFrameRow, index: number) => boolean
): DataFrame {
  return {
    ...dataFrame,
    rows: dataFrame.rows.filter((dataRow, index) => predicate(dataRow, index)),
  };
}
